import Header from "components/Header";
import ManageFundingRequestV2 from "features/main/HaulPay/Shared/EditFundingRequestV2/Manage";
import MainLayout from "layouts/Main";
import { BrokerProvider } from "context/BrokerContext";

export default function BrokerFundingRequestV2() {
  return (
    <BrokerProvider>
      <MainLayout
        desktopTitle="Manage Pay"
        customHeader={<Header label="Funding Request" />}
        className="h-full mobile:!overflow-y-hidden"
        hideNavigation>
        <div className="mobile:h-full">
          <ManageFundingRequestV2 />
        </div>
      </MainLayout>
    </BrokerProvider>
  );
}
